



























import Vue from "vue";
import { defineComponent } from "@vue/composition-api";
import ModalContainer from "@/components/ModalContainer.vue";
import { castComponent } from "@/lib/helpers";
import { VContainer, VBtn } from "vuetify/lib";

Vue.component("ModalContainer", ModalContainer);
Vue.component("VContainer", castComponent(VContainer));
Vue.component("VBtn", castComponent(VBtn));

export default defineComponent({
  name: "ModalConfirm",
});
